import { ApiUtility } from "./ApiUtility";
import { notifyFavoriteMutation } from "../utils/favoriteFeedback";

class AudiosService {
  route = "/posts";
  audioRoute = "/api/" + localStorage.getItem("type") + "?lang=";

  private getLangParam(): string {
    const lan = localStorage.getItem("lan") || "hindi";
    return lan === "hi" ? "hindi" : lan === "en" ? "english" : lan;
  }
  categoryRoute = "/api/settings/filters?lang=";
  categoryRouteAudio = "/api/Audios/Categories?lang=";
  pravachanfav = "/api/pravachans/";
  audiofavroute = "/api/audios/";
  pravachanwithid = "/api/Pravachans/";
  dailysatsang = "/api/DailySatsang?lang=";
  years = "/api/Pravachans/yearrange";
  time = "/api/Settings/Time?lang=hindi";
  dailySatsangfavroute = "/api/DailySatsang/"
  audioPodcast = "/api/AudioPodcast?lang=";

  getAudioPodcast = (
    start: number,
    length: number,
    sort: string,
    month: string = "0",
    year: string = "0"
  ) => {
    return ApiUtility.get(
      this.audioPodcast +
      this.getLangParam() +
      "&start=" +
      start +
      "&length=" +
      length +
      "&sort=" +
      sort +
      "&month=" +
      month +
      "&year=" +
      year
    );
  };

  getDailySatsang = (
    search: string,
    start: number,
    length: number,
    sort: string,
    month: string,
    year: string,
    authorId: string,
    lyrics: number,
    startDate?: string,
    endDate?: string
  ) => {
    let url =
      this.dailysatsang +
      this.getLangParam() +
      "&search=" +
      search +
      "&start=" +
      start +
      "&length=" +
      length +
      "&sort=" +
      sort +
      "&authorId=" +
      authorId +
      "&lyrics=" +
      lyrics;

    if (startDate && endDate) {
      url += "&startDate=" + startDate + "&endDate=" + endDate;
    } else {
      url += "&month=" + month + "&year=" + year;
    }

    return ApiUtility.get(url);
  };

  getPravachanFilters = (productFor: string, authorId?: string) => {
    let url =
      this.categoryRoute +
      this.getLangParam() +
      "&productFor=" +
      productFor;
    if (authorId) {
      url += "&authorId=" + authorId;
    }
    return ApiUtility.get(url);
  };

  getFilters = (productFor: string, authorId?: string) => {
    let url =
      this.categoryRoute +
      this.getLangParam() +
      "&productFor=" +
      productFor;
    if (authorId) {
      url += "&authorId=" + authorId;
    }
    return ApiUtility.get(url);
  };

  GetAuthorDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/Audios/Authors/${identifier}?lang=` + this.getLangParam()
    );
  }

  GetLanguageDataById(id: string) {
    return ApiUtility.get(
      `/api/languages/${id}?lang=` + this.getLangParam()
    );
  }

  /** Resolve audio category by Mongo id or slug (same identifier rule as books). */
  GetCategoryDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/Audios/Categories/${identifier}?lang=` + this.getLangParam()
    );
  }

  getAudioCategories = (authorId?: any) => {
    const lang = this.getLangParam() || "";
    const params: string[] = [];
    if (lang) {
      params.push(`lang=${encodeURIComponent(lang)}`);
    }
    if (authorId) {
      params.push(`authorId=${encodeURIComponent(authorId)}`);
    }
    const queryString = params.length ? `?${params.join("&")}` : "";
    return ApiUtility.get(`/api/Audios/Categories${queryString}`);
  };

  getYearReaponse() {
    return ApiUtility.get(this.years + "?ispravachan=true");
  }

  getTimeReaponse() {
    return ApiUtility.get(this.time);
  }

  getAudiosById = (id: string, type: string) => {
    return ApiUtility.get(
      "/api/" + type + "/" + id + "?lang=" + this.getLangParam()
    );
  };

  // getAudioDetail = (id: string) => {
  //   const lang = this.getLangParam() || "hindi";
  //   return ApiUtility.get(`${this.kalpatarudetailRoute}${id}/SEO?lang=${lang}`);
  // };

  getAudios = (
    start: number,
    length: number,
    IsChildLiterature: boolean,
    categoryId: string,
    authorId: string,
    search: string,
    sort: string,
    langId: string,
    isSpecial: boolean,
    type: string,
    lyrics: number = 0,
    month: string,
    year: string,
    userId?: string,
    ptime?: string,
    isOther?: boolean,
    date?: string
  ) => {
    if (type === "audios") {
      return ApiUtility.get(
        "/api/" +
        "audios" +
        "?lang=" +
        this.getLangParam() +
        "&start=" +
        start +
        "&length=" +
        length +
        "&categoryId=" +
        categoryId +
        "&IsChildLiterature=" +
        IsChildLiterature +
        "&authorId=" +
        authorId +
        "&search=" +
        search +
        "&sort=" +
        sort +
        "&lyrics=" +
        lyrics +
        "&audioLangauge=" +
        langId +
        "&isSpecial=" +
        isSpecial
      );
    } else {
      // API rejects date=0 / day-of-month; only send dd-MM-yyyy when a real day is selected
      const logdetails: string[] = [];
      const hasValidDate = Boolean(date && /^\d{2}-\d{2}-\d{4}$/.test(date));
      logdetails.push(`trigger=getAudios_pravachans year=${year} month=${month} date=${date || ""} validDate=${hasValidDate} isSpecial=${isSpecial} isOther=${isOther} authorId=${authorId || ""}`);

      let url =
        "/api/" +
        "pravachans" +
        "?lang=" +
        this.getLangParam() +
        "&start=" +
        start +
        "&length=" +
        length +
        "&categoryId=" +
        categoryId +
        "&IsChildLiterature=" +
        IsChildLiterature +
        "&authorId=" +
        authorId +
        "&search=" +
        search +
        "&sort=" +
        sort +
        "&audioLangauge=" +
        langId +
        "&isSpecial=" +
        isSpecial +
        "&lyrics=" +
        lyrics +
        "&month=" +
        month +
        "&year=" +
        year +
        "&isOther=" +
        isOther;

      if (hasValidDate) {
        url += "&date=" + date;
      }
      if (ptime) {
        url += "&ptime=" + ptime;
      }

      console.log("AudiosService.getAudios ->", logdetails.join(" | "));
      return ApiUtility.get(url);
    }
  };

  getaudioandpravachanbyid = (id: string) => {

    if (localStorage.getItem("type") === "audios") {
      return ApiUtility.get(
        this.audiofavroute +
        id +
        "?lang=" +
        this.getLangParam()
      );
    } else if (localStorage.getItem("type") === "DailySatsang") {
      return ApiUtility.get(
        this.dailySatsangfavroute +
        id +
        "?lang=" +
        this.getLangParam()
      );
    }
    else {
      return ApiUtility.get(
        this.pravachanwithid +
        id +
        "?lang=" +
        this.getLangParam()
      );
    }
  };

  addPravachanFavourite = (id: string) => {
    return notifyFavoriteMutation(ApiUtility.post(this.pravachanfav + id + "/favourite", {}), "pravachan", "added");
  };

  removePravachanFaviourite = (id: string) => {
    return notifyFavoriteMutation(ApiUtility.delete(this.pravachanfav + id + "/favourite"), "pravachan", "removed");
  };

  addAudioFavourite = (id: string) => {
    return notifyFavoriteMutation(ApiUtility.post(this.audiofavroute + id + "/favourite", {}), "audio", "added");
  };

  removeAudioFavourite(id: string) {
    return notifyFavoriteMutation(ApiUtility.delete(this.audiofavroute + id + "/favourite"), "audio", "removed");
  }

  addDailySatsangFavourite = (id: string) => {
    return notifyFavoriteMutation(ApiUtility.post(this.dailySatsangfavroute + id + "/favourite", {}), "dailySatsang", "added");
  };

  removeDailySatsangFavourite(id: string) {
    return notifyFavoriteMutation(ApiUtility.delete(this.dailySatsangfavroute + id + "/favourite"), "dailySatsang", "removed");
  }

}
export default new AudiosService();
